export const categories = [
  {
    slug: "drama",
    name: "日韩剧集",
    icon: "ri-tv-line",
    description: "最新最全的日韩电视剧集，涵盖爱情、悬疑、职场、古装等多种类型",
    color: "from-rose-500 to-orange-400",
  },
  {
    slug: "movie",
    name: "日韩电影",
    icon: "ri-film-line",
    description: "院线热映与经典佳片，日韩电影爱好者的天堂",
    color: "from-amber-500 to-yellow-400",
  },
  {
    slug: "anime",
    name: "动漫番剧",
    icon: "ri-anchor-line",
    description: "热门新番与经典动漫，二次元世界的无限精彩",
    color: "from-emerald-500 to-teal-400",
  },
  {
    slug: "variety",
    name: "综艺娱乐",
    icon: "ri-emotion-laugh-line",
    description: "日韩热门综艺节目，欢乐不断笑料百出",
    color: "from-cyan-500 to-sky-400",
  },
  {
    slug: "music",
    name: "音乐现场",
    icon: "ri-music-line",
    description: "日韩音乐盛典、演唱会、MV高清合集",
    color: "from-violet-500 to-purple-400",
  },
  {
    slug: "documentary",
    name: "纪录片",
    icon: "ri-global-line",
    description: "深度探索日韩文化、历史、美食与自然风光",
    color: "from-teal-500 to-green-400",
  },
];

export const featuredContent = [
  {
    id: 1,
    title: "东京爱情故事 2026 重制版",
    category: "drama",
    image: "https://readdy.ai/api/search-image?query=Romantic%20Japanese%20drama%20scene%20in%20Tokyo%20cityscape%20at%20sunset%2C%20couple%20walking%20under%20cherry%20blossoms%2C%20warm%20cinematic%20lighting%2C%20soft%20focus%2C%20emotional%20atmosphere%2C%20film%20grain%20texture%2C%20elegant%20composition%2C%20nostalgic%20mood%2C%20clean%20minimal%20background&width=800&height=450&seq=feat-1&orientation=landscape",
    rating: 9.5,
    updateDate: "2026-08-04",
    description: "经典日剧全新重制，4K画质重温平成时代的爱情经典，每一帧都是回忆",
  },
  {
    id: 2,
    title: "首尔大作战：极限挑战",
    category: "variety",
    image: "https://readdy.ai/api/search-image?query=Korean%20variety%20show%20set%20with%20colorful%20neon%20lights%2C%20dynamic%20game%20challenge%20scene%2C%20energetic%20atmosphere%2C%20studio%20lighting%2C%20professional%20broadcast%20production%2C%20clean%20vibrant%20background&width=800&height=450&seq=feat-2&orientation=landscape",
    rating: 9.3,
    updateDate: "2026-08-03",
    description: "韩国王牌综艺最新季，明星嘉宾极限对决，爆笑不断的真人挑战",
  },
  {
    id: 3,
    title: "进击的巨人 最终季 完结篇",
    category: "anime",
    image: "https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20with%20dramatic%20sky%2C%20cinematic%20lighting%2C%20dynamic%20action%20composition%2C%20dark%20atmospheric%20mood%2C%20professional%20animation%20art%20style%2C%20clean%20minimal%20background%2C%20high%20contrast&width=800&height=450&seq=feat-3&orientation=landscape",
    rating: 9.8,
    updateDate: "2026-08-02",
    description: "现象级动漫神作最终章，史诗级战斗场面，为十年的传奇画上句号",
  },
  {
    id: 4,
    title: "寄生虫 导演剪辑加长版",
    category: "movie",
    image: "https://readdy.ai/api/search-image?query=Korean%20cinematic%20film%20scene%20with%20dramatic%20lighting%2C%20luxurious%20modern%20house%20interior%2C%20suspenseful%20atmosphere%2C%20Oscar%20winning%20movie%20aesthetic%2C%20clean%20composition%2C%20high%20production%20value%2C%20elegant%20color%20grading&width=800&height=450&seq=feat-4&orientation=landscape",
    rating: 9.7,
    updateDate: "2026-08-01",
    description: "奥斯卡最佳影片导演剪辑版，新增30分钟未公开画面，深度解读社会寓言",
  },
];

export const latestContent = [
  {
    id: 5,
    title: "京都和风纪行 第三季",
    category: "documentary",
    image: "https://readdy.ai/api/search-image?query=Kyoto%20traditional%20Japanese%20temple%20with%20autumn%20maple%20leaves%2C%20serene%20zen%20garden%2C%20soft%20natural%20lighting%2C%20documentary%20cinematography%2C%20peaceful%20atmosphere%2C%20clean%20minimal%20composition&width=600&height=340&seq=latest-1&orientation=landscape",
    rating: 9.1,
    updateDate: "2026-08-05",
    duration: "45分钟/集",
    episode: "更新至第8集",
  },
  {
    id: 6,
    title: "梨泰院Class 特别篇",
    category: "drama",
    image: "https://readdy.ai/api/search-image?query=Korean%20drama%20night%20scene%20in%20Itaewon%20street%20with%20colorful%20restaurant%20neon%20signs%2C%20warm%20atmospheric%20lighting%2C%20young%20entrepreneur%20vibe%2C%20cinematic%20composition%2C%20clean%20urban%20background&width=600&height=340&seq=latest-2&orientation=landscape",
    rating: 9.0,
    updateDate: "2026-08-05",
    duration: "60分钟",
    episode: "全16集",
  },
  {
    id: 7,
    title: "鬼灭之刃 无限城篇",
    category: "anime",
    image: "https://readdy.ai/api/search-image?query=Japanese%20anime%20demon%20slayer%20style%20action%20scene%20with%20flame%20effects%2C%20dynamic%20sword%20fight%2C%20dramatic%20lighting%2C%20traditional%20Japanese%20aesthetic%2C%20cinematic%20animation%20quality%2C%20clean%20minimal%20background&width=600&height=340&seq=latest-3&orientation=landscape",
    rating: 9.6,
    updateDate: "2026-08-04",
    duration: "24分钟/集",
    episode: "更新至第3集",
  },
  {
    id: 8,
    title: "Running Man 2026",
    category: "variety",
    image: "https://readdy.ai/api/search-image?query=Korean%20outdoor%20variety%20show%20game%20scene%20in%20bright%20daylight%2C%20energetic%20group%20activity%2C%20colorful%20name%20tags%2C%20professional%20broadcast%20production%2C%20clean%20natural%20background&width=600&height=340&seq=latest-4&orientation=landscape",
    rating: 8.9,
    updateDate: "2026-08-04",
    duration: "90分钟/集",
    episode: "更新至第678集",
  },
  {
    id: 9,
    title: "灌篮高手 全国大赛篇",
    category: "anime",
    image: "https://readdy.ai/api/search-image?query=Japanese%20basketball%20anime%20scene%20in%20gym%20court%2C%20dramatic%20slam%20dunk%20moment%2C%20dynamic%20sports%20action%2C%20retro%2090s%20anime%20art%20style%2C%20clean%20minimal%20background%2C%20inspiring%20atmosphere&width=600&height=340&seq=latest-5&orientation=landscape",
    rating: 9.9,
    updateDate: "2026-08-03",
    duration: "90分钟",
    episode: "剧场版",
  },
  {
    id: 10,
    title: "Mnet亚洲音乐大奖2026",
    category: "music",
    image: "https://readdy.ai/api/search-image?query=K-pop%20music%20award%20show%20stage%20with%20spectacular%20lighting%20effects%2C%20large%20LED%20screen%2C%20enthusiastic%20audience%2C%20professional%20concert%20production%2C%20clean%20dark%20background%20with%20spotlights&width=600&height=340&seq=latest-6&orientation=landscape",
    rating: 9.2,
    updateDate: "2026-08-03",
    duration: "180分钟",
    episode: "完整版",
  },
];

export const allContent = [
  ...featuredContent,
  ...latestContent,
  {
    id: 11,
    title: "与君相恋100次 日版",
    category: "movie",
    image: "https://readdy.ai/api/search-image?query=Japanese%20romantic%20movie%20scene%20in%20music%20room%20with%20warm%20sunlight%2C%20vintage%20record%20player%2C%20nostalgic%20young%20love%20atmosphere%2C%20soft%20cinematic%20lighting%2C%20clean%20minimal%20composition&width=600&height=340&seq=all-1&orientation=landscape",
    rating: 8.8,
    updateDate: "2026-08-02",
    duration: "117分钟",
    episode: "完整版",
  },
  {
    id: 12,
    title: "深夜食堂 第五季",
    category: "drama",
    image: "https://readdy.ai/api/search-image?query=Japanese%20cozy%20tiny%20restaurant%20at%20night%20with%20warm%20lantern%20glow%2C%20steaming%20food%20on%20counter%2C%20intimate%20atmosphere%2C%20cinematic%20lighting%2C%20clean%20minimal%20composition&width=600&height=340&seq=all-2&orientation=landscape",
    rating: 9.4,
    updateDate: "2026-08-01",
    duration: "25分钟/集",
    episode: "全10集",
  },
  {
    id: 13,
    title: "BTS 釜山演唱会实录",
    category: "music",
    image: "https://readdy.ai/api/search-image?query=Massive%20K-pop%20concert%20in%20stadium%20with%20ocean%20of%20light%20sticks%2C%20spectacular%20stage%20production%2C%20fireworks%2C%20professional%20live%20performance%2C%20clean%20dark%20background&width=600&height=340&seq=all-3&orientation=landscape",
    rating: 9.7,
    updateDate: "2026-07-30",
    duration: "150分钟",
    episode: "完整版",
  },
  {
    id: 14,
    title: "寿司之神 加长版",
    category: "documentary",
    image: "https://readdy.ai/api/search-image?query=Japanese%20sushi%20master%20crafting%20nigiri%20in%20traditional%20tiny%20restaurant%2C%20warm%20intimate%20lighting%2C%20steaming%20rice%2C%20fresh%20fish%20on%20wooden%20counter%2C%20documentary%20style%2C%20clean%20minimal%20composition&width=600&height=340&seq=all-4&orientation=landscape",
    rating: 9.3,
    updateDate: "2026-07-29",
    duration: "95分钟",
    episode: "完整版",
  },
  {
    id: 15,
    title: "半泽直树 第三季",
    category: "drama",
    image: "https://readdy.ai/api/search-image?query=Japanese%20corporate%20office%20drama%20scene%20with%20intense%20confrontation%2C%20modern%20Tokyo%20skyscraper%20interior%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20professional%20atmosphere%2C%20clean%20minimal%20background&width=600&height=340&seq=all-5&orientation=landscape",
    rating: 9.5,
    updateDate: "2026-07-28",
    duration: "54分钟/集",
    episode: "全10集",
  },
  {
    id: 16,
    title: "你的名字 4K修复版",
    category: "movie",
    image: "https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20scene%20with%20beautiful%20starry%20night%20sky%2C%20comet%20falling%2C%20dreamy%20atmosphere%2C%20rural%20Japanese%20town%20landscape%2C%20cinematic%20animation%20art%2C%20clean%20minimal%20composition&width=600&height=340&seq=all-6&orientation=landscape",
    rating: 9.6,
    updateDate: "2026-07-27",
    duration: "106分钟",
    episode: "完整版",
  },
];

export const faqList = [
  {
    question: "aaa日韩平台的内容是否为正版授权？",
    answer: "是的，aaa日韩平台所有内容均已获得正版授权，与日本、韩国多家头部内容制作公司和版权方建立了长期合作关系。我们严格遵守国际版权法规，确保每一位用户都能放心观看正版内容，享受最优质的观影体验。",
  },
  {
    question: "平台支持哪些设备观看？",
    answer: "aaa日韩支持多终端同步播放，包括Web网页端、iOS/Android移动端、平板电脑、智能电视等主流设备。您只需一个账号，即可在所有设备上无缝切换观看，播放进度自动同步。",
  },
  {
    question: "是否需要付费才能观看？",
    answer: "aaa日韩提供免费体验入口，新用户注册即可获得一定时长的免费观影权益。同时我们也提供VIP会员服务，会员可享受无广告、超高清4K画质、离线下载、抢先观看等专属特权。",
  },
  {
    question: "内容更新频率如何？",
    answer: "我们每日持续更新内容资源，热门日韩剧集通常在日本或韩国播出后24小时内更新中文字幕版本。综艺节目和动漫番剧也会在第一时间同步上线，确保您不会错过任何精彩内容。",
  },
  {
    question: "支持哪些语言字幕？",
    answer: "aaa日韩平台所有内容默认提供简体中文字幕，部分热门内容同时提供繁体中文字幕、英文字幕和日韩双语字幕。字幕由专业翻译团队精心制作，确保翻译质量。",
  },
  {
    question: "如何联系客服获取帮助？",
    answer: "您可以通过关于我们页面的在线表单提交问题，或发送邮件至我们的官方客服邮箱。我们的客服团队工作时间为每日9:00-24:00，通常在2小时内回复。VIP会员享有一对一专属客服服务。",
  },
];

export const testimonials = [
  {
    name: "张先生",
    location: "北京",
    rating: 5,
    comment: "用了aaa日韩三年了，资源更新速度真的快，画质也一直很清晰。日剧迷的福音！",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%20in%20casual%20style%2C%20simple%20light%20gray%20background%2C%20friendly%20expression%2C%20clean%20minimal%20headshot&width=80&height=80&seq=avatar-1&orientation=squarish",
  },
  {
    name: "李女士",
    location: "上海",
    rating: 5,
    comment: "韩综爱好者狂喜！Running Man每期都第一时间更新，字幕翻译也很用心。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20in%20modern%20style%2C%20simple%20light%20gray%20background%2C%20warm%20smile%2C%20clean%20minimal%20headshot&width=80&height=80&seq=avatar-2&orientation=squarish",
  },
  {
    name: "王同学",
    location: "广州",
    rating: 5,
    comment: "动漫资源太全了！新番老番都有，多端同步看真的太方便了，上课路上也能追番。",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20with%20glasses%2C%20simple%20light%20gray%20background%2C%20casual%20friendly%20look%2C%20clean%20minimal%20headshot&width=80&height=80&seq=avatar-3&orientation=squarish",
  },
];